export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
export const SET_MODAL_CLOSED = 'SET_MODAL_CLOSED';
export const ADD_MODAL = 'ADD_MODAL';
export const SET_MODAL_START_SUBMITTING = 'SET_MODAL_START_SUBMITTING';
export const SET_MODAL_STOP_SUBMITTING = 'SET_MODAL_STOP_SUBMITTING';
